import { Loading, useShowQuery } from "@dgs/core";
import { FC } from "react";
import { Navigate, useParams } from "react-router";
import { contactService } from "../shared/api/contactService";

export const RedirectToContact: FC = () => {
	const { id = "" } = useParams();
	const { data: contact } = useShowQuery(id, contactService);

	if (!contact) {
		return <Loading />;
	}

	if (contact.isArchived) {
		return <Navigate to={`/contacts/archived/${contact.id}`} replace={true} />;
	} else {
		return <Navigate to={`/contacts/active/${contact.id}`} replace={true} />;
	}
};
